import React from 'react'
import "./App.css";
// @ts-ignore
import Sidebar from "./components/Sidebar";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// @ts-ignore
import { DSDash, DSRiskGrade, DSTrendChart, DSTop5, DSTop10, DSDatacat, DSActivescans, DSLast5, DSScheduledscans, DSMitprogress } from "./pages/DSDash";
// @ts-ignore
import { Agentstatus } from "./pages/Agentstatus";
// @ts-ignore
import { DSSched, DSSelectcat, DSSelectagent, DSRunningscans } from "./pages/DSSched";
// @ts-ignore
import { DSProgress, DSSnapshot } from "./pages/DSProgress";
// @ts-ignore
import { DSHistory } from "./pages/DSHistory";
// @ts-ignore
import { VSDash, VSRiskGrade, VSTrendChart, VSTop5, VSTop10, VSAllvulnhosts, VSActivescans, VSLast5, VSScheduledscans, VSMitprogress } from "./pages/VSDash";
// @ts-ignore
import { VSSched, VSAgent, VSTarget, VSSubmit } from "./pages/VSSched";
// @ts-ignore
import { VSProgress } from "./pages/VSProgress";
// @ts-ignore
import { VSHistory, VSSnapshot, VSSummary } from "./pages/VSHistory";
// @ts-ignore
import { VSPatchman, VSRootcause, VSPatchsched, VSPatchhist } from "./pages/VSPatchman";
// @ts-ignore
import { VSLookup } from "./pages/VSLookup";
// @ts-ignore
import { VSCompare } from "./pages/VSCompare";
// @ts-ignore
import { SBDash, SBRiskGrade, SBOverview, SBTop5, SBTrendchart, SBTop10, SBOSList, SBActivescans, SBLast5, SBScheduledscans, SBMitprogress } from "./pages/SBDash";
// @ts-ignore
import { SBSched, SBAgents, SBScheduled } from "./pages/SBSched";
// @ts-ignore
import { SBProgress, SBLive } from "./pages/SBProgress";
// @ts-ignore
import { SBHistory } from "./pages/SBHistory";
// @ts-ignore
import { SBLookup } from "./pages/SBLookup";
// @ts-ignore
import { CPMan, CPADResults, CPMSSecscore, CPMSSecactions, CPRiskassess, CPReports } from "./pages/CPMan";
// @ts-ignore
import { MITDash, MITKeyperf, MITActive } from "./pages/MITDash";
// @ts-ignore
import { MITPlan, MITCreate, MITTargets, MITSubplan, MITCreatesub } from "./pages/MITPlan";
// @ts-ignore
import { MITReview, MITPlanreview } from "./pages/MITReview";
// @ts-ignore
import { Reportbuilder } from "./pages/Reportbuilder";
// @ts-ignore
import { DWEnroll, DWResult } from "./pages/DWEnroll";
// @ts-ignore
import { ADUsers, ADUserform, ADUserexist, ADDepts, ADCustomdepts } from "./pages/ADUsers";
// @ts-ignore
import { ADTargets, ADNewtarget, ADNetdisco, ADNewdisco } from "./pages/ADTargets";
// @ts-ignore
import { ADAgents, ADPrereq, ADInstall, ADProvision, ADUpdate, ADStatus, ADPerms } from "./pages/ADAgents";
// @ts-ignore
import { ADSystem, AD3rdparty, ADO365, ADGoogle, ADNewregex, ADUpdateregex, ADKeywords } from "./pages/ADSystem";
// @ts-ignore
import { ORDash, ORRiskGrade, ORRiskbycat, ORRiskfin, ORDWValue, RWRecovery, Breachcost, Residualcost, Comptracker, ProgramKPI, Riskmatrix, Trendchart, Datascans, Mitigationplans} from "./pages/ORDash";
// @ts-ignore
import Contact from "./pages/ContactUs";
// @ts-ignore
import Support from "./pages/Support";
function App() {
  return (
    <Router>
      <Sidebar />
      <Routes>
        <Route path='/ORDash' element={<ORDash/>} />
        <Route path='/ORDash/ORRiskGrade' element={<ORRiskGrade/>} />
        <Route path='/ORDash/ORRiskbycat' element={<ORRiskbycat/>} />
        <Route path='/ORDash/ORRiskfin' element={<ORRiskfin/>} />
        <Route path='/ORDash/ORDWValue' element={<ORDWValue/>} />
        <Route path='/ORDash/RWRecovery' element={<RWRecovery/>} />
        <Route path='/ORDash/Breachcost' element={<Breachcost/>} />
        <Route path='/ORDash/Residualcost' element={<Residualcost/>} />
        <Route path='/ORDash/Comptracker' element={<Comptracker/>} />
        <Route path='/ORDash/ProgramKPI' element={<ProgramKPI/>} />
        <Route path='/ORDash/Riskmatrix' element={<Riskmatrix/>} />
        <Route path='/ORDash/Trendchart' element={<Trendchart/>} />
        <Route path='/ORDash/Datascans' element={<Datascans/>} />
        <Route path='/ORDash/Mitigationplans' element={<Mitigationplans/>} />
        <Route path='/Agentstatus' element={<Agentstatus/>} />
        <Route path='/DSDash' element={<DSDash/>} />
        <Route path='/DSDash/DSRiskGrade' element={<DSRiskGrade/>} />
        <Route path='/DSDash/DSTrendChart' element={<DSTrendChart/>} />
        <Route path='/DSDash/DSTop5' element={<DSTop5/>} />
        <Route path='/DSDash/DSTop10' element={<DSTop10/>} />
        <Route path='/DSDash/DSDatacat' element={<DSDatacat/>} />
        <Route path='/DSDash/DSActivescans' element={<DSActivescans/>} />
        <Route path='/DSDash/DSLast5' element={<DSLast5/>} />
        <Route path='/DSDash/DSScheduledscans' element={<DSScheduledscans/>} />
        <Route path='/DSDash/DSMitprogress' element={<DSMitprogress/>} />
        <Route path='/VSDash' element={<VSDash/>} />
        <Route path='/VSDash/VSRiskGrade' element={<VSRiskGrade/>} />
        <Route path='/VSDash/VSTrendChart' element={<VSTrendChart/>} />
        <Route path='/VSDash/VSTop5' element={<VSTop5/>} />
        <Route path='/VSDash/VSTop10' element={<VSTop10/>} />
        <Route path='/VSDash/VSAllvulnhosts' element={<VSAllvulnhosts/>} />
        <Route path='/VSDash/VSActivescans' element={<VSActivescans/>} />
        <Route path='/VSDash/VSLast5' element={<VSLast5/>} />
        <Route path='/VSDash/VSScheduledscans' element={<VSScheduledscans/>} />
        <Route path='/VSDash/VSMitprogress' element={<VSMitprogress/>} />
        <Route path='/DSSched' element={<DSSched/>} />
        <Route path='/DSSched/DSSched' element={<DSSched/>} />
        <Route path='/DSSched/DSSelectcat' element={<DSSelectcat/>} />
        <Route path='/DSSched/DSSelectagent' element={<DSSelectagent/>} />
        <Route path='/DSSched/DSRunningscans' element={<DSRunningscans/>} />
        <Route path='/DSProgress' element={<DSProgress/>} />
        <Route path='/DSProgress/DSProgress' element={<DSProgress/>} />
        <Route path='/DSProgress/DSSnapshot' element={<DSSnapshot/>} />
        <Route path='/DSHistory' element={<DSHistory/>} />
        <Route path='/DSHistory/DSHistory' element={<DSHistory/>} />
        <Route path='/VSSched' element={<VSSched/>} />
        <Route path='/VSSched/VSSched' element={<VSSched/>} />
        <Route path='/VSSched/VSAgent' element={<VSAgent/>} />
        <Route path='/VSSched/VSTarget' element={<VSTarget/>} />
        <Route path='/VSSched/VSSubmit' element={<VSSubmit/>} />
        <Route path='/VSProgress' element={<VSProgress/>} />
        <Route path='/VSProgress/VSProgress' element={<VSProgress/>} />
        <Route path='/VSHistory' element={<VSHistory/>} />
        <Route path='/VSHistory/VSHistory' element={<VSHistory/>} />
        <Route path='/VSHistory/VSSnapshot' element={<VSSnapshot/>} />
        <Route path='/VSHistory/VSSummary' element={<VSSummary/>} />
        <Route path='/VSPatchman' element={<VSPatchman/>} />
        <Route path='/VSPatchman/VSPatchman' element={<VSPatchman/>} />
        <Route path='/VSPatchman/VSRootcause' element={<VSRootcause/>} />
        <Route path='/VSPatchman/VSPatchsched' element={<VSPatchsched/>} />
        <Route path='/VSPatchman/VSPatchhist' element={<VSPatchhist/>} />
        <Route path='/VSLookup' element={<VSLookup/>} />
        <Route path='/VSLookup/VSLookup' element={<VSLookup/>} />
        <Route path='/VSCompare' element={<VSCompare/>} />
        <Route path='/VSCompare/VSCompare' element={<VSCompare/>} />
        <Route path='/SBDash' element={<SBDash/>} />
        <Route path='/SBDash/SBRiskGrade' element={<SBRiskGrade/>} />
        <Route path='/SBDash/SBOverview' element={<SBOverview/>} />
        <Route path='/SBDash/SBTop5' element={<SBTop5/>} />
        <Route path='/SBDash/SBTrendchart' element={<SBTrendchart/>} />
        <Route path='/SBDash/SBTop10' element={<SBTop10/>} />
        <Route path='/SBDash/SBOSList' element={<SBOSList/>} />
        <Route path='/SBDash/SBActivescans' element={<SBActivescans/>} />
        <Route path='/SBDash/SBLast5' element={<SBLast5/>} />
        <Route path='/SBDash/SBScheduledscans' element={<SBScheduledscans/>} />
        <Route path='/SBDash/SBMitprogress' element={<SBMitprogress/>} />
        <Route path='/SBSched' element={<SBSched/>} />
        <Route path='/SBSched/SBSched' element={<SBSched/>} />
        <Route path='/SBSched/SBAgents' element={<SBAgents/>} />
        <Route path='/SBSched/SBScheduled' element={<SBScheduled/>} />
        <Route path='/SBProgress' element={<SBProgress/>} />
        <Route path='/SBProgress/SBProgress' element={<SBProgress/>} />
        <Route path='/SBProgress/SBLive' element={<SBLive/>} />
        <Route path='/SBHistory' element={<SBHistory/>} />
        <Route path='/SBLookup' element={<SBLookup/>} />
        <Route path='/CPMan' element={<CPMan/>} />
        <Route path='/CPMAN/CPMan' element={<CPMan/>} />
        <Route path='/CPMAN/CPADResults' element={<CPADResults/>} />
        <Route path='/CPMAN/CPMSSecscore' element={<CPMSSecscore/>} />
        <Route path='/CPMAN/CPMSSecactions' element={<CPMSSecactions/>} />
        <Route path='/CPMAN/CPRiskassess' element={<CPRiskassess/>} />
        <Route path='/CPMAN/CPReports' element={<CPReports/>} />
        <Route path='/MITDash' element={<MITDash/>} />
        <Route path='/MITDash/MITDash' element={<MITDash/>} />
        <Route path='/MITDash/MITKeyperf' element={<MITKeyperf/>} />
        <Route path='/MITDash/MITActive' element={<MITActive/>} />
        <Route path='/MITPlan' element={<MITPlan/>} />
        <Route path='/MITPlan/MITPlan' element={<MITPlan/>} />
        <Route path='/MITPlan/MITCreate' element={<MITCreate/>} />
        <Route path='/MITPlan/MITTargets' element={<MITTargets/>} />
        <Route path='/MITPlan/MITSubplan' element={<MITSubplan/>} />
        <Route path='/MITPlan/MITCreatesub' element={<MITCreatesub/>} />
        <Route path='/MITReview' element={<MITReview/>} />
        <Route path='/MITReview/MITReview' element={<MITReview/>} />
        <Route path='/MITReview/MITPlanreview' element={<MITPlanreview/>} />
        <Route path='/Reportbuilder' element={<Reportbuilder/>} />
        <Route path='/DWEnroll' element={<DWEnroll/>} />
        <Route path='/DWEnroll/DWEnroll' element={<DWEnroll/>} />
        <Route path='/DWEnroll/DWResult' element={<DWResult/>} />
        <Route path='/ADUsers' element={<ADUsers/>} />
        <Route path='/ADUsers/ADUsers' element={<ADUsers/>} />
        <Route path='/ADUsers/ADUserform' element={<ADUserform/>} />
        <Route path='/ADUsers/ADUserexist' element={<ADUserexist/>} />
        <Route path='/ADUsers/ADDepts' element={<ADDepts/>} />
        <Route path='/ADUsers/ADCustomdepts' element={<ADCustomdepts/>} />
        <Route path='/ADTargets' element={<ADTargets/>} />
        <Route path='/ADTargets/ADTargets' element={<ADTargets/>} />
        <Route path='/ADTargets/ADNewtarget' element={<ADNewtarget/>} />
        <Route path='/ADTargets/ADNetdisco' element={<ADNetdisco/>} />
        <Route path='/ADTargets/ADNewdisco' element={<ADNewdisco/>} />
        <Route path='/ADAgents' element={<ADAgents/>} />
        <Route path='/ADAgents/ADAgents' element={<ADAgents/>} />
        <Route path='/ADAgents/ADPrereq' element={<ADPrereq/>} />
        <Route path='/ADAgents/ADInstall' element={<ADInstall/>} />
        <Route path='/ADAgents/ADProvision' element={<ADProvision/>} />
        <Route path='/ADAgents/ADUpdate' element={<ADUpdate/>} />
        <Route path='/ADAgents/ADStatus' element={<ADStatus/>} />
        <Route path='/ADAgents/ADPerms' element={<ADPerms/>} />
        <Route path='/ADSystem' element={<ADSystem/>} />
        <Route path='/ADSystem/ADSystem' element={<ADSystem/>} />
        <Route path='/ADSystem/AD3rdparty' element={<AD3rdparty/>} />
        <Route path='/ADSystem/ADO365' element={<ADO365/>} />
        <Route path='/ADSystem/ADGoogle' element={<ADGoogle/>} />
        <Route path='/ADSystem/ADNewregex' element={<ADNewregex/>} />
        <Route path='/ADSystem/ADUpdateregex' element={<ADUpdateregex/>} />
        <Route path='/ADSystem/ADKeywords' element={<ADKeywords/>} />
        <Route path="*" element={<Navigate to="/ORDash" replace />} />
      </Routes>
    </Router>
  );
}
   
export default App;